var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-base',[_c('div',{attrs:{"id":"watch_main"}},[_c('div',{attrs:{"id":"watch_grid"}},[(_vm.video)?_c('watch-video',{attrs:{"video":_vm.video,"startTime":_vm.startTime}}):_vm._e(),(false)?_c('watch-section'):_vm._e()],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }